export type StatusKind = 'good' | 'attention' | 'critical' | 'info';

const ICONS: Record<StatusKind, string> = { good: '✓', attention: '!', critical: '✕', info: 'i' };

/** A status shown as an icon AND a word, never colour alone (for example "✓ Reconciled", "✕ Overdue"). */
export function StatusBadge({ kind, children }: { kind: StatusKind; children: string }) {
  return (
    <span className={`ed-status ed-status--${kind}`}>
      <span className="ed-status__icon" aria-hidden="true">{ICONS[kind]}</span>
      {children}
    </span>
  );
}
